<template>
  <div class="box">
    <HTTPresponse :alert="httpalert" @changeHTTPBoxState="HTTPState"></HTTPresponse>
    <v-layout
      d-block
      d-md-flex
      row
      ma-0
      align-center
      justify-space-between
      class="box-header"
    >
      <template v-if="content && content.length > 0">
        <template v-for="(item, index) in content">
          <h3 v-if="item.type === 'title' && item.text" :key="index" v-html="item.text"></h3>
          <h3
            v-else-if="item.type === 'title' && !item.text"
            :key="index"
            v-html="survey.info.status !== 'sent' &&
                    survey.info.status !== 'verify' &&
                    survey.info.status !== 'success' &&
                    survey.info.status !== 'failed' ?
                    $t('submit-audit.title-1') : $t('submit-audit.title-2')"></h3>
        </template>
      </template>
    </v-layout>

    <div class="box-content">
      <!-- btn box -->
      <div class="text-center mb-4">
        <!-- <v-btn
          :elevation="0"
          rounded
          color="primary"
          @click="send"
          :disabled="survey.info.status !== 'sent' &&
                     survey.info.status !== 'verify' &&
                     survey.done.point >= survey.total.requiredpt &&
                     survey.done.mandatoryq === survey.total.mandatoryq ? false : true"
        >{{ $t("submit-audit.btn-1") }}</v-btn> -->
        <template
          v-if="survey.info.status === 'sent' ||
                survey.info.status === 'verify' ||
                survey.info.status === 'success' ||
                survey.info.status === 'failed'"
        >
          <!-- <v-btn
            class="mx-1 my-1"
            :elevation="0"
            rounded
            small
            color="primary"
            @click="PDFfn(survey)"
            :loading="loadPDF"
          >{{ $t("submit-audit.btn-2") }}</v-btn> -->
          <v-btn
            class="mx-1 my-1"
            :elevation="0"
            rounded
            small
            color="primary"
            :disabled="pdf ? false : true"
            :href="pdf"
            :download="unescaped(survey.info[`title_${$i18n.locale}`])"
            target="_blank"
          >{{ $t("submit-audit.btn-2") }}</v-btn>
          <v-btn
            class="mx-1 my-1"
            :elevation="0"
            rounded
            small
            color="primary"
            :disabled="pdffull ? false : true"
            :href="pdffull"
            :download="unescaped(survey.info[`title_${$i18n.locale}`])"
            target="_blank"
          >{{ $t("submit-audit.btn-3") }}</v-btn>
        </template><!-- if not finalize -->
        <template v-else>
          <v-btn
            :elevation="0"
            rounded
            color="primary"
            @click="send"
            :disabled="survey.info.status !== 'sent' &&
                      survey.info.status !== 'verify' &&
                      survey.info.status !== 'success' &&
                      survey.info.status !== 'failed' &&
                      parseInt(survey.done.point ? survey.done.point : 0) >= parseInt(survey.total.requiredpt ? survey.total.requiredpt : 0) &&
                (parseInt(survey.done.mandatoryq ? survey.done.mandatoryq : 0) - parseInt(survey.done.derogations ? survey.done.derogations : 0)) >= ((parseInt(survey.total.mandatoryq ? survey.total.mandatoryq : 0) - parseInt(survey.total.maxderogations ? survey.total.maxderogations : 0))) ? false : true"
          >{{ $t("submit-audit.btn-1") }}</v-btn>
        </template>
      </div>

      <!-- content -->
      <template v-if="content && content.length > 0">
        <template v-for="(item, index) in content">
          <p v-if="item.type === 'text' && item.text" :key="index">
            <pre v-html="item.text"></pre>
          </p>
          <h4 v-if="item.type === 'subtitle' && item.text" :key="index" class="mb-4 text-center" v-html="item.text"></h4>
        </template>
      </template>
  </div>
  </div>
</template>

<script>
import { sendSurvey } from '@/js/survey/sendSurvey'
import { getStatic } from '@/js/static/getStatic'
import { makePDF } from '@/js/utils/makePDF'
import { randomBaseUrl } from '@/js/utils/randomBaseUrl'
import HTTPresponse from '@/components/app/HTTPresponse'

export default {
  props: {
    answerid: String,
    survey: Object|Array,
    firm: Object|Array
  },
  components: {
    HTTPresponse: HTTPresponse
  },

  data () {
    return {
      content: null,
      loadPDF: false,
      httpalert: false,

      // zip: this.answerid && this.$store.state.auth.token ? randomBaseUrl(0, 3) + process.env.VUE_APP_DOWNLOAD_ZIP + `?options=json&answerid=${this.answerid}&valid=${this.$store.state.auth.token}` : null,
      pdf: this.answerid && this.$store.state.auth.token ? randomBaseUrl(0, 3) + process.env.VUE_APP_DOWNLOAD2_ZIP + `?&answerid=${this.answerid}&lang=${this.$i18n.locale ? this.$i18n.locale : 'en'}&valid=${this.$store.state.auth.token}&options=pdf` : null,
      pdffull: this.answerid && this.$store.state.auth.token ? randomBaseUrl(0, 3) + process.env.VUE_APP_DOWNLOAD2_ZIP + `?&answerid=${this.answerid}&lang=${this.$i18n.locale ? this.$i18n.locale : 'en'}&valid=${this.$store.state.auth.token}` : null,
    }
  },

  methods: {
    send () {
      // if (!this.$store.getters['auth/isAuthenticated']) return

      const params = {
        answerid: this.answerid,
        key: this.$store.state.auth.token
      }
      sendSurvey(params)
        .then(response => {
          this.$router.push({ name: 'certificate-request',
                              params: { survey: this.survey, answerid: this.answerid, firm: this.firm }})
        })
        .catch(() => {
          this.httpalert = true
          setTimeout(() => {
            this.httpalert = false
          }, 4000)
        })
    },

    PDFfn (val) {
      // if (!this.$store.getters['auth/isAuthenticated']) return
      this.loadPDF = true
      makePDF(val, this.answerid, this.$store.state.auth.token, this.firm)
        .then(() => this.loadPDF = false)
        .catch(() => this.loadPDF = false)
    },

    HTTPState (value) {
      this.httpalert = this.value
    },

    unescaped (string) {
      var txt = document.createElement('textarea')
      txt.innerHTML = string
      return txt.value
    }
  },

  created () {
    const params1 ={
      lang: this.$i18n.locale ? this.$i18n.locale : 'en',
      page: 'finalreport',
      keyword: this.survey.info.status != 'sent' &&
               this.survey.info.status != 'verify' &&
               this.survey.info.status !== 'success' &&
               this.survey.info.status !== 'failed' ? 'submitbox' : 'send'
    } 
    getStatic(params1)
      .then(response => this.content = response.modules)
      // .catch(error => console.log(error))
  }
}
</script>
